export const styles = (theme) => ({
  containerIconMenu: {
    border: "1px solid #ff513f8a",
    display: "flex",
    width: "2rem",
    height: "2rem",
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "#ffffffba",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  containerArround: {
    width: "8rem",
    margin: "auto",
    position: "relative",
  },
  iconMenu: {
    color: "#ff513f",
  },
  containerImageRound: {
    border: "1px solid #ffffff",
    position: "relative",
    borderRadius: "50%",
    margin: "auto",
    width: "8rem",
    // boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    objectFit: "cover",
    borderWidth: "2px",
  },
  cameraRound: {
    bottom: -6,
    right: 24,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "2rem",
    height: "2rem",
    border: "1px solid #fff",
    backgroundColor: " #ff513f",
    borderRadius: "50%",
    cursor: "pointer",
  },
  iconCameraRound: {
    width: "1.3rem",
  },
  containerImage: {
    cursor: "pointer",
    position: "relative",
    "&:hover $changeCover": {
      display: "block",
    },
  },
  containerImageWidth45vw: {
    width: "45vw",
    cursor: "pointer",
    position: "relative",
    "&:hover $changeCover": {
      display: "block",
    },
  },
  changeCover: {
    transition: "0.3s",
    display: "none",
    position: "absolute",
    right: "2rem",
    bottom: "2rem",
    "& button": {
      backgroundColor: "white !important",
    },
  },
  camera: {
    bottom: -12,
    right: -12,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "2rem",
    height: "2rem",
    border: "4px solid #fff",
    backgroundColor: " #ff513f",
    borderRadius: "50%",
    cursor: "pointer",
  },
  iconCamera: {
    width: "1.3rem",
  },
  image: {
    objectFit: "contain",
    // width: '45vw',

    backgroundSize: "cover",
    backgroundPosition: "center",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
    "& img": {
      objectFit: "contain",
    },
  },
  menuFontSize: {
    fontSize: "0.8rem",
  },
});
